import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

const state = {
  /**
   * 请求头信息
   */
  // headers: {
  //   identification: '',//设备信息
  // },
  manageState: false,
  token: '',
  menu: {},
  shopInfo: {},
  platform: '',
  platforminfo: {},
  domain: '',
  previewData: {},
  intercept: '',
  noticeUpdate: '', //消息更新
  power: {
    storeId: null, // 店铺id
    userId: null, // 用户id
    router: [], // 可访问的路由
    menuList: [] // 对应可见菜单
  },
  memberState: -1, //开通旺铺状态
  openPopupModel: false // 开通服务确认弹窗
};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters: {
   
  }
});
